import { render, staticRenderFns } from "./Enquiry.vue?vue&type=template&id=04ffae06"
import script from "./Enquiry.vue?vue&type=script&lang=js"
export * from "./Enquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports